// extracted by mini-css-extract-plugin
export default {"container":"centerButtons_container__SGLq+","button":"centerButtons_button__ni50d","active":"centerButtons_active__Iv8ec"};